// @flow
import styled from "styled-components"
import { mq } from "common/mediaQuery"

export const ButtonsWrap = styled.div`
  margin: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  & > button {
    margin: 0.5rem;
  }
  ${mq.tabletWide} {
    justify-content: space-between;
  }
`



// WEBPACK FOOTER //
// ./src/pages/Checkout/CheckoutForm/ConfirmExtension/styled.js